import { Route } from "@angular/router";
import { FormViewComponent } from "./view/form-view.component";
import { FormCollectComponent } from "./collect/form-collect.component";
import { FormBuilderComponent } from "./builder/form-builder.component";

export const defaultBuilderRoutes: Route[] = [
    {
        path: "builder",
        component: FormBuilderComponent,
    },
    {
        path: "preview",
        component: FormViewComponent,
    },
    {
        path: "collect",
        component: FormCollectComponent,
    },
];
